import { z } from 'zod'

const JoyfulErrorBodySchema = z.object({
  detail: z.string().optional(),
  message: z.string().optional(),
})

type JoyfulErrorBody = z.infer<typeof JoyfulErrorBodySchema>

interface ErrorWithBody extends Error {
  body: JoyfulErrorBody
}

function isJoyfulError(error: unknown): error is ErrorWithBody {
  return (
    error instanceof Error &&
    'body' in error &&
    JoyfulErrorBodySchema.safeParse(error.body).success === true
  )
}

export function extractErrorMessage(error: unknown) {
  if (isJoyfulError(error)) {
    // API returns either 'message' (JoyfulException) or 'detail' (FastAPI validation)
    return error.body.message ?? error.body.detail
  }

  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === 'string') {
    return error
  }

  return `${String(error)}`
}
